module.exports = __webpack_public_path__ + "static/media/country_do.f768eec0.webp";